import { Event, Material, Color, createPropertyDescriptor, defined, Property } from 'cesium';

const CircleRippleMaterialSource = `
uniform vec4 color;
uniform float speed;
uniform float count;
uniform float gradient;
czm_material czm_getMaterial(czm_materialInput materialInput)
{
czm_material material = czm_getDefaultMaterial(materialInput);
material.diffuse = 1.5 * color.rgb;
vec2 st = materialInput.st;
float dis = distance(st, vec2(0.5, 0.5));
float per = fract(czm_frameNumber * speed / 1000.0);
if(count == 1.0){
    if(dis > per * 0.5){
    discard;
    }else {
    material.alpha = color.a  * dis / per / 2.0;
    }
} else {
    vec3 str = materialInput.str;
    if(abs(str.z)  > 0.001){
    discard;
    }
    if(dis > 0.5){
    discard;
    } else {
    float perDis = 0.5 / count;
    float disNum;
    float bl = 0.0;
    for(int i = 0; i <= 999; i++){
        if(float(i) <= count){
        disNum = perDis * float(i) - dis + per / count;
        if(disNum > 0.0){
            if(disNum < perDis){
            bl = 1.0 - disNum / perDis;
            }
            else if(disNum - perDis < perDis){
            bl = 1.0 - abs(1.0 - disNum / perDis);
            }
            material.alpha = pow(bl,(1.0 + 10.0 * (1.0 - gradient)));
        }
        }
    }
    }
}
return material;
}`;

/**
 * 圆形扫描以及圆形扩散的类对象
 * @alias EV_CircleScan
 * @constructor
 * @param {Viewer} viewer       视图对象
 */

function CircleRippleMaterialProperty(options) {
    this._definitionChanged = new Event();
    this._color = options.color;
    this._speed = options.speed;
    this.color = options.color;
    this.speed = options.speed;
    this.count = options.count;
    this.gradient = options.gradient;
    //   Cesium.CircleRippleMaterialProperty = CircleRippleMaterialProperty;
    Material.CircleRippleMaterialProperty = 'CircleRippleMaterialProperty';
    Material.CircleRippleMaterialType = 'CircleRippleMaterialType';
    Material.CircleRippleMaterialSource = CircleRippleMaterialSource;
    //   if (defined(customMaterial)) {
    //     if (defined(customMaterial.FShader)) {
    //       Material.PolylineTrailLinkSource = customMaterial.FShader;
    //     }
    //     if (defined(customMaterial.ColorImage)) {
    //       Material.PolylineTrailLinkImage = customMaterial.ColorImage;
    //     }
    //   }
    Material._materialCache.addMaterial(Material.CircleRippleMaterialType, {
        fabric: {
            type: Material.CircleRippleMaterialType,
            uniforms: {
                color: new Color(1.0, 1.0, 0.0, 1.0),
                speed: 3.0,
                count: 4,
                gradient: 0.2,
                scale: 1.0, // 设置固定的缩放因子
            },
            source: Material.CircleRippleMaterialSource,
        },
        translucent: function(material) {
            return true;
        },
    });
}

Object.defineProperties(CircleRippleMaterialProperty.prototype, {
    isConstant: {
        get: function() {
            return false;
        },
    },
    definitionChanged: {
        get: function() {
            return this._definitionChanged;
        },
    },
    color: createPropertyDescriptor('color'),
    speed: createPropertyDescriptor('speed'),
    count: createPropertyDescriptor('count'),
    gradient: createPropertyDescriptor('gradient'),
});

CircleRippleMaterialProperty.prototype.getType = function(time) {
    return Material.CircleRippleMaterialType;
};

CircleRippleMaterialProperty.prototype.getValue = function(time, result) {
    if (!defined(result)) {
        result = {};
    }
    result.color = Property.getValueOrDefault(this._color, time, Color.RED, result.color);
    result.speed = Property.getValueOrDefault(this._speed, time, 10, result.speed);

    result.count = this.count;
    result.gradient = this.gradient;
    return result;
};

CircleRippleMaterialProperty.prototype.equals = function(other) {
    return (
        this === other ||
        (other instanceof CircleRippleMaterialProperty &&
            Property.equals(this._color, other._color) &&
            Property.equals(this._speed, other._speed) &&
            Property.equals(this.count, other.count) &&
            Property.equals(this.gradient, other.gradient))
    );
};

export default CircleRippleMaterialProperty;
